import { render, staticRenderFns } from "./DynamicCompassBar.vue?vue&type=template&id=334eb2ee&scoped=true&"
import script from "./DynamicCompassBar.vue?vue&type=script&lang=ts&"
export * from "./DynamicCompassBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334eb2ee",
  null
  
)

export default component.exports